function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M15,9.5 C14.171,9.5 13.5,8.828 13.5,8 C13.5,7.172 14.171,6.5 15,6.5 C15.829,6.5 16.5,7.172 16.5,8 C16.5,8.828 15.829,9.5 15,9.5 M10,17 C7.103,17 4.704,15.147 4.294,12.734 C4.229,12.351 4.563,12 5.011,12 L14.989,12 C15.437,12 15.771,12.351 15.706,12.734 C15.296,15.147 12.897,17 10,17 M3.5,8 C3.5,7.172 4.171,6.5 5,6.5 C5.829,6.5 6.5,7.172 6.5,8 C6.5,8.828 5.829,9.5 5,9.5 C4.171,9.5 3.5,8.828 3.5,8 M10,0 C4.477,0 0,4.478 0,10 C0,15.522 4.477,20 10,20 C15.523,20 20,15.522 20,10 C20,4.478 15.523,0 10,0",
  id: "path-1"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/emoji.82355794.svg";
export { SvgComponent as ReactComponent };